import commonConstant from '../../common/_commonConstant';
import {
  createCookieToken,
  getCookieToken,
  deleteCookieToken,
  createCookieUserId,
  deleteCookieUserId,
  createCookieExpires,
  deleteCookieExpires,
  getCookieUserId,
} from '../../common/_commonFunction';
import { history } from '../../helpers';

export const fetchLogin = fromLogin => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users/login`, {
        'method': 'POST',
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }),
        'body': JSON.stringify(fromLogin),
      });
      const data = await res.json();

      if (res.status === 200) {
        createCookieToken(data.data.accessToken, data.data.expireAt);
        createCookieUserId(data.data.userID, data.data.expireAt);
        createCookieExpires(data.data.expireAt, data.data.expireAt);
        return dispatch({
          'type': commonConstant.LOGIN_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.LOGIN_FAILURE,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      return dispatch({
        'type': commonConstant.LOGIN_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.LOGIN_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchLogout = () => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users/logout`, {
        'method': 'POST',
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });

      if (getCookieToken()) {
        deleteCookieToken();
        deleteCookieUserId();
        deleteCookieExpires();
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.LOGOUT_SUCCESS,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      return dispatch({
        'type': commonConstant.LOGOUT_FAILURE,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.LOGOUT_FAILURE,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchRefreshToken = () => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/access-tokens.refresh-token`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (res.status === 200) {
        createCookieToken(data.data.accessToken, data.data.expire);
        createCookieUserId(getCookieUserId(), data.data.expire);
        createCookieExpires(data.data.expire, data.data.expire);
        return dispatch({
          'type': commonConstant.REFRESH_TOKEN_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      return dispatch({
        'type': commonConstant.REFRESH_TOKEN_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.REFRESH_TOKEN_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);
